"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoyEnum = void 0;
const codec_1 = require("@polkadot/types/codec");
// Helper for creating extended Enum type with TS-compatible isOfType and asType helpers
function JoyEnum(types) {
    var _a;
    return _a = class JoyEnumObject extends codec_1.Enum.with(types) {
            // eslint-disable-next-line no-useless-constructor
            constructor(registry, value, index) {
                super(registry, value, index);
                this.typeDefinitions = JoyEnumObject.typeDefinitions; // Non-static version
            }
            static create(registry, typeKey, value) {
                return new JoyEnumObject(registry, { [typeKey]: value });
            }
            isOfType(typeKey) {
                return this.type === typeKey;
            }
            asType(typeKey) {
                if (!this.isOfType(typeKey)) {
                    throw new Error(`Enum.asType(${typeKey}) - value is not of type ${typeKey}`);
                }
                return this.value;
            }
        },
        _a.typeDefinitions = types,
        _a;
}
exports.JoyEnum = JoyEnum;
